// extracted by mini-css-extract-plugin
export default {"container":"registerPage_container__T40Fc","details":"registerPage_details__0eMEU","login":"registerPage_login__OEkxP"};